import { createLucideIcon } from 'lucide-react';

const RailSymbolIcon = createLucideIcon('RailSymbol', [
  [
    'path',
    {
      d: 'M5 15H19M5 9H19M14 20L9 15L15 9L10 4',
      key: '1',
    },
  ],
]);

RailSymbolIcon.displayName = 'RailSymbolIcon';

export default RailSymbolIcon;
